<script>
    import { onMount } from "svelte";
    import { v4 } from "uuid";
    import CustomDateInput from "../Custom/DateInput/CustomDateInput.svelte";
    import { resetDefaultStyle } from "../../Utils/utilFunctions.svelte";
    import { createEventDispatcher } from "svelte";

    export let placeholder = "",
        value = null,
        isDisable = false,
        id = "",
        showTime = false,
        showYearDropdown = true,
        minDate = "",
        inputClass,
        showAbove = false,
        showRight = false,
        wrapperClass = "",
        wrapperClassFocus = "",
        maxDate = "",
        showClearButton = false,
        handleInput = () => {};

    export let minYear,
        maxYear,
        showScrollYearOptions = false,
        yearOptionSize;

    $: min = minDate ? new Date(minDate) : new Date("1900-01-01");
    $: max = maxDate ? new Date(maxDate) : new Date("2999-12-31");

    const uuid = v4(),
        dispatch = createEventDispatcher();

    let displayValue = null,
        refValue = new Date();

    onMount(() => {
        if (value) {
            displayValue = new Date(value);
            refValue = new Date(value);
        } else displayValue = null;

        min = minDate ? new Date(minDate) : new Date("1900-01-01");
        max = maxDate ? new Date(maxDate) : new Date("2999-12-31");

        handleSelectDate();

        const dateInput = document.getElementById(id ? id : uuid);

        if (dateInput)
            dateInput.addEventListener("focus", () => {
                resetDefaultStyle(id ? id : uuid);
            });

        const containers = document.querySelectorAll(".date-time-field");

        containers.forEach((element) => {
            element.classList.remove("w-full");
            element.classList.add("w-full");
        });
    });

    export const refreshValue = () => {
        if (value) {
            displayValue = new Date(value);
            refValue = new Date(value);
        } else displayValue = null;
    };

    $: if (value) {
        displayValue = new Date(value);
        refValue = new Date(value);
    }

    $: if (!value) {
        displayValue = null;
    }

    const handleSelectDate = () => {
        const originalDate = displayValue ? new Date(displayValue) : null;

        if (originalDate) {
            const year = originalDate.getFullYear();
            const month = (originalDate.getMonth() + 1)
                .toString()
                .padStart(2, "0");
            const day = originalDate.getDate().toString().padStart(2, "0");

            const hours = originalDate.getHours().toString().padStart(2, "0");
            const minutes = originalDate
                .getMinutes()
                .toString()
                .padStart(2, "0");
            const seconds = originalDate
                .getSeconds()
                .toString()
                .padStart(2, "0");

            value = showTime
                ? `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
                : `${year}-${month}-${day}`;
        } else {
            value = null;
            dispatch("valueCleared");
        }
    };

    let containerElement;
</script>

<div class="flex flex-1 w-full no-transform" bind:this={containerElement}>
    <CustomDateInput
        bind:value={displayValue}
        closeOnSelection="true"
        format={showTime ? "dd/MM/yyyy HH:mm" : "dd/MM/yyyy"}
        valid="true"
        {inputClass}
        {placeholder}
        id={id ? id : uuid}
        {min}
        {max}
        {showTime}
        {showAbove}
        {showRight}
        {wrapperClass}
        {wrapperClassFocus}
        {showYearDropdown}
        {showClearButton}
        {containerElement}
        timePrecision="minute"
        disabled={isDisable}
        browseWithoutSelecting
        dynamicPositioning
        on:change={() => {
            handleSelectDate();
            dispatch("change");
            handleInput(value);
            resetDefaultStyle(id ? id : uuid);
        }}
        {minYear}
        {maxYear}
        {showScrollYearOptions}
        {yearOptionSize}
    />
</div>
